<script>
  import { Button, Modal } from "carbon-components-svelte";
  import { fetchWrapper } from "lib/util/fetchWrapper.js";
  import { TextArea } from "paxray-components-svelte";

  export let currentStep, idproject;

  let blacklist = "";
  let submitModalOpen = false;

  function saveSimpleBlacklist() {
    let blacklistlist = blacklist.split("\n");
    let blackListItems = [];
    blacklistlist.forEach((element) => {
      if (element.trim())
        blackListItems.push({
          name: "",
          appname: element.trim(),
          windowtitleorurl: element.trim(),
          reason: "",
        });
    });
    fetchWrapper(`/api/damprojects/saveUserLimitations/${idproject}/black`, {
      method: "POST",
      body: JSON.stringify([{ user: blackListItems }]),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status == "success") {
          currentStep = 6;
          submitModalOpen = false;
        }
      });
  }
</script>

<div style="margin:20px;">
  <h2>Blacklist Applications and Websites</h2>
  <TextArea
    bind:value={blacklist}
    rows="20"
    placeholder="Enter Applications or Websites that should not be included in the analysis"
  ></TextArea>
  <Button
    on:click={() => {
      submitModalOpen = true;
    }}>Save</Button
  >
</div>

<Modal
  bind:open={submitModalOpen}
  modalHeading="Submit Entries"
  primaryButtonText="Submit"
  secondaryButtonText="Cancel"
  preventCloseOnClickOutside
  on:click:button--secondary={() => (submitModalOpen = false)}
  on:open
  on:close={() => (submitModalOpen = false)}
  on:submit={saveSimpleBlacklist}
>
  <p>Do you want to submit your entries?</p>
  <p>This is a permanent action and cannot be undone.</p>
</Modal>
